import { getDisplays } from '../Display';
import { objectHasOwnProperty } from '../Utility';
import { Zone } from '../Zone';
import { Widget } from './Widget';

type WidgetAction = (widget: Widget) => void;

class WidgetCollection {
    m_Widgets: Widget[];

    constructor(widgets: Widget[]) {
        this.m_Widgets = widgets;
    }

    /**
     * @deprecated
     */
    Do(actionOrActions: PropertyKey | PropertyKey[]): void {
        if (!Array.isArray(actionOrActions)) {
            actionOrActions = [actionOrActions];
        }

        actionOrActions.forEach((action) => {
            this.m_Widgets.forEach((widget) => {
                if (objectHasOwnProperty(widget, action)) {
                    if (typeof widget[action] === 'function') {
                        const fnAction: () => void = widget[action] as () => void;
                        fnAction();
                    }
                }
            });
        });
    }

    /**
     * @deprecated
     */
    Each(actionOrActions: WidgetAction | WidgetAction[]): void {
        if (!Array.isArray(actionOrActions)) {
            actionOrActions = [actionOrActions];
        }

        actionOrActions.forEach((action) => {
            this.m_Widgets.forEach((widget) => {
                action(widget);
            });
        });
    }

    /**
     * @deprecated
     */
    First(): Widget | undefined {
        return this.m_Widgets[0];
    }
}

/**
 * @deprecated
 */
export const Widgets = {
    /**
     * Find widgets by name, and returns a collection with the Do and Each fn.
     * @deprecated
     */
    FindByName(nameOrNames: string | string[]): WidgetCollection {
        if (!Array.isArray(nameOrNames)) {
            nameOrNames = [nameOrNames];
        }

        const flatDisplayZones: Zone[] = getDisplays()
            .map((d) => d.zones)
            .flat();
        const filteredWidgets: Widget[] = [];
        flatDisplayZones.forEach((zone) => {
            if (zone.widgets && zone.widgets.length) {
                zone.widgets.forEach((widget) => {
                    if (nameOrNames.includes(widget.name)) {
                        filteredWidgets.push(widget);
                    }
                });
            }
        });

        return new WidgetCollection(filteredWidgets);
    },
};
